import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";

interface SubscriptionPlansProps {
  currentTier?: string;
  onUpgrade: (tier: string) => void;
}

interface PlanFeature {
  features: string[];
  price: string;
  description: string;
  popular?: boolean;
}

export const SubscriptionPlans = ({ currentTier, onUpgrade }: SubscriptionPlansProps) => {
  const plans: Record<string, PlanFeature> = {
    intro: {
      price: "99",
      description: "For personal use",
      features: [
        "All features",
        "Export data in JSON & CSV",
        "1,000 credits per month",
        "1 seat",
        "API access"
      ]
    },
    explorer: {
      price: "199",
      description: "For professionals",
      features: [
        "All Intro features",
        "Mail support",
        "3,000 credits per month",
        "Access to beta features",
        "3 seats"
      ],
      popular: true
    },
    enterprise: {
      price: "499",
      description: "For large teams",
      features: [
        "All Explorer features",
        "10K credits per month",
        "Dedicated account manager",
        "Custom feature requests",
        "5 seats"
      ]
    }
  };

  return (
    <div className="space-y-4">
      <div className="grid md:grid-cols-3 gap-6">
        {Object.entries(plans).map(([tier, plan]) => (
          <Card key={tier} className={`flex flex-col ${plan.popular ? 'border-primary shadow-lg' : ''}`}>
            <CardHeader>
              <CardTitle>{tier.charAt(0).toUpperCase() + tier.slice(1)}</CardTitle>
              <CardDescription>{plan.description}</CardDescription>
            </CardHeader>
            <CardContent className="flex-1">
              <div className="text-3xl font-bold mb-2">${plan.price}<span className="text-lg font-normal">/month</span></div>
              <ul className="space-y-2 mb-4">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-2">
                    <Check className="h-4 w-4 text-green-500" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
            <CardFooter>
              <Button 
                className="w-full" 
                onClick={() => onUpgrade(tier)}
                disabled={currentTier === tier}
                variant={plan.popular ? "default" : "outline"}
              >
                {currentTier === tier ? 'Current Plan' : 'Upgrade'}
              </Button>
            </CardFooter>
          </Card>
        ))}
      </div>
    </div>
  );
};